import { render, staticRenderFns } from "./NotiChangePw.vue?vue&type=template&id=d974b960&scoped=true"
import script from "./NotiChangePw.vue?vue&type=script&lang=js"
export * from "./NotiChangePw.vue?vue&type=script&lang=js"
import style0 from "./NotiChangePw.vue?vue&type=style&index=0&id=d974b960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d974b960",
  null
  
)

export default component.exports